<template>
    <div>
        <div class="hero _overlay" v-scroll-reveal>
            <div class="hero-content text-center">
                <h1 class="text-white leading-none">Villa Kanedolo</h1>
                <div class="separator"></div>
                <p class="text-white" v-html="$t('index.title')"></p>
            
                <router-link :to="{ name: 'booking', params: { locale: $i18n.locale() } }" class="btn text-white mt-gap xl:mt-gap-lg" exact v-html="$t('btn.book')"></router-link>
            </div>
            <img src="/img/safe-in-croatia.png" alt="safe in croatia" class="safe-absolute">

        </div>

        <overview></overview>
        <gallery></gallery>
        <reviews></reviews>
        <facilities></facilities>
        <location></location>
        <contact></contact>
        <booking></booking>
    </div>
</template>

<script>
import Overview from './partials/index/Overview.vue'
import Gallery from './partials/index/Gallery.vue'
import Reviews from './partials/index/Reviews.vue'
import Facilities from './partials/index/Facilities.vue'
import Location from './partials/index/Location.vue'
import Contact from './partials/index/Contact.vue'
import Booking from './partials/index/Booking.vue'

export default {
    components: {
        Overview,
        Gallery,
        Reviews,
        Facilities,
        Location,
        Contact,
        Booking,
    }
}
</script>
